import modalProposalFavouriteTemplate from '../../view/angular/common/modal/modal-proposal-favourite.tpl.html';

angular
  .module('jrFavouriteJobsModule', ['jrConfig', 'jrModal', 'jrTracking', 'jrCommonService'])
  .value('modalProposalFavouriteTemplate', modalProposalFavouriteTemplate)
  .service('FavouriteJobsSerpService', FavouriteJobsSerpService)
  .controller('FavouriteJobsSerpController', FavouriteJobsSerpController);

FavouriteJobsSerpService.$inject = ['$http', 'FavouriteJobsConfig', 'SearchResultsConfig'];
FavouriteJobsSerpController.$inject = [
  'FavouriteJobsSerpService',
  'SearchConfig',
  'SearchResultsConfig',
  'JobseekerConfig',
  'SearchFormService',
  'ModalProposalService',
  'GoogleTagManagerTrackingService',
  'modalProposalFavouriteTemplate',
];

function FavouriteJobsSerpService($http, FavouriteJobsConfig, SearchResultsConfig) {
  return {
    getFavouriteJobs,
    deleteFavouriteJob,
    addFavouriteJob,
    checkJobseekerFavouriteJobs,
  };

  function getFavouriteJobs(id, country) {
    const advertIdQueryString = buildAdvertIdQueryString();

    return $http
      .get(
        `${buildServiceUrl()}/favourite-jobs/?jobseekerId=${id}&country=${country}${
          advertIdQueryString.length > 0 ? `&${advertIdQueryString}` : ''
        }`
      )
      .then(getFavouriteJobsComplete);
  }

  function addFavouriteJob(userId, advertId, where, country) {
    return $http.post(`${buildServiceUrl()}/favourite-jobs/`, {
      jobseekerId: userId,
      advertId,
      location: where,
      country,
    });
  }

  function deleteFavouriteJob(id) {
    return $http.delete(`${buildServiceUrl()}/favourite-jobs/${id}`);
  }

  function checkJobseekerFavouriteJobs(id, country) {
    return $http.head(`${buildServiceUrl()}/favourite-jobs/?jobseekerId=${id}&country=${country}`);
  }

  function getFavouriteJobsComplete(response) {
    return response.data;
  }

  function buildServiceUrl() {
    let port = '';
    if (FavouriteJobsConfig.port !== '') {
      port = `:${FavouriteJobsConfig.port}`;
    }
    return FavouriteJobsConfig.url + port;
  }

  function buildAdvertIdQueryString() {
    const keys = typeof SearchResultsConfig === 'object' ? Object.keys(SearchResultsConfig) : [];

    return keys.length > 0 ? keys.map((id) => `advertId=${id}`).join('&') : '';
  }
}

function FavouriteJobsSerpController(
  FavouriteJobsSerpService,
  SearchConfig,
  SearchResultsConfig,
  JobseekerConfig,
  SearchFormService,
  ModalProposalService,
  GoogleTagManagerTrackingService,
  modalProposalFavouriteTemplate
) {
  const vm = this;

  vm.adverts = [];
  vm.getFavouriteJobs = getFavouriteJobs;
  vm.updateJob = updateJob;
  vm.isSaved = isSaved;
  vm.isFirst = isFirst;
  vm.isJobseekerLogged = isJobseekerLogged;
  vm.openProposal = openProposal;
  vm.first = '';
  vm.hasResults = false;

  check();
  activate();

  function activate() {
    return getFavouriteJobs(JobseekerConfig.id, SearchConfig.country);
  }

  function check(afterAdd, addedAdvertId) {
    return checkJobseekerFavouriteJobs(
      JobseekerConfig.id,
      SearchConfig.country,
      afterAdd,
      addedAdvertId
    );
  }

  function checkJobseekerFavouriteJobs(userId, country) {
    return FavouriteJobsSerpService.checkJobseekerFavouriteJobs(userId, country).then(function (
      data
    ) {
      const hits = parseInt(data.headers('Favourite-Jobs-Total-Hits'), 10);
      if (hits > 0) {
        vm.hasResults = true;
      } else {
        vm.hasResults = false;
      }
    });
  }

  function getFavouriteJobs(userId, country) {
    return FavouriteJobsSerpService.getFavouriteJobs(userId, country).then(function (data) {
      vm.adverts = data;
      if (JobseekerConfig.hardLogin || JobseekerConfig.weakLogin) {
        if (vm.adverts.length === 1) {
          setFirst(data[0].advertId);
        } else if (vm.adverts.length === 0) {
          setFirst('');
        }
      }
      return vm.adverts;
    });
  }

  function updateJob(advertId) {
    if (JobseekerConfig.hardLogin) {
      if (vm.isSaved(advertId)) {
        deleteFavouriteJob(JobseekerConfig.id, advertId);
      } else {
        addFavouriteJob(
          JobseekerConfig.id,
          advertId,
          SearchResultsConfig[advertId].location,
          SearchConfig.country
        );
      }
    } else {
      openProposal();
      if (!vm.isSaved(advertId)) {
        addFavouriteJob(
          JobseekerConfig.id,
          advertId,
          SearchResultsConfig[advertId].location,
          SearchConfig.country
        );
      }
    }
  }

  function addFavouriteJob(userId, advertId, where, country) {
    return FavouriteJobsSerpService.addFavouriteJob(userId, advertId, where, country).then(
      function (data) {
        dataLayer.push({
          event: 'favouritejobs.add',
          advertId,
        });
        check(true, data.data.advertId);
        return getFavouriteJobs(userId, country);
      }
    );
  }

  function deleteFavouriteJob(jobseekerId, advertId) {
    const jobId = `${jobseekerId}-${advertId}`;
    return FavouriteJobsSerpService.deleteFavouriteJob(jobId).then(function (data) {
      dataLayer.push({
        event: 'favouritejobs.delete',
        advertId,
      });
      check();
      return getFavouriteJobs(JobseekerConfig.id, SearchConfig.country);
    });
  }

  function setFirst(id) {
    vm.first = id;
  }

  function isFirst(id) {
    return id === vm.first;
  }

  function isSaved(id) {
    for (let i = 0; i < vm.adverts.length; i += 1) {
      if (vm.adverts[i].advertId === id) {
        return true;
      }
    }
    return false;
  }

  function isJobseekerLogged() {
    return JobseekerConfig.isLogged;
  }

  function openProposal() {
    const windowClass = [];
    windowClass.push(jrConfigGlobal.socialLogin.enabled ? 'social' : '');

    GoogleTagManagerTrackingService.trackFavouriteJobsProposal();
    ModalProposalService.openModalProposal({
      resolve: {
        search() {
          return angular.copy(SearchFormService.search);
        },
        afterSubscriptionCallback() {
          return GoogleTagManagerTrackingService.trackFavouriteJobsSubscription;
        },
        afterSocialSubscriptionCallback() {
          return GoogleTagManagerTrackingService.trackSocialFavouriteJobsSubscription;
        },
      },
      windowClass: windowClass.join(' '),
      template: modalProposalFavouriteTemplate,
    });
  }
}
